import { render } from "./Factura.vue?vue&type=template&id=85d5fc58"
import script from "./Factura.vue?vue&type=script&lang=js"
export * from "./Factura.vue?vue&type=script&lang=js"
script.render = render

export default script